import angular from 'angular';
import { postPinFooterComponent } from './postPinFooterComponent';
import 'components/sharpr/post/actions/postActionsModule';

angular
	.module('sh.postPinFooter', ['sh.likeButton', 'sh.commentButton', 'sh.postActions'])
	.component('shPostPinFooter', postPinFooterComponent());
